import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { NoteActions } from './note.actions';
import { NoteSelectors } from './note.selectors';

@Injectable({ providedIn: 'root' })
export class NoteStore {
  state$ = this.store.select(NoteSelectors.getState());
  note$ = this.store.select(NoteSelectors.getNote());

  constructor(private store: Store) {}

  getNote(installationId: string): void {
    this.store.dispatch(NoteActions.getNote({ installationId }));
  }

  deleteNote(installationId: string): void {
    this.store.dispatch(NoteActions.deleteNote({ installationId }));
  }

  addNote(installationId: string, note: string): void {
    this.store.dispatch(NoteActions.addNote({ installationId, note }));
  }
}
